export const background = '#0c1d34';
export const highlight = '#6FE793';
export const highlight_text = '#0C1D34';
export const lightBlue = '#163359';
export const lightBlue_text = '#e5e5e5';
export const wrong = '#E36655';
